import { ApiModule } from '@core';
import type { Crop } from '../models/crop.model';

export class CropApi extends ApiModule {
  protected endpoint = '/crop';

  public listCrops() {
    return this.api.get<Crop[]>(this.endpoint);
  }
}
